module.exports = __webpack_public_path__ + "img/logo.fd1f0f7a.png";